/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentPlanViewModel } from './InvestmentPlanViewModel';
import {
    InvestmentPlanViewModelFromJSON,
    InvestmentPlanViewModelFromJSONTyped,
    InvestmentPlanViewModelToJSON,
} from './InvestmentPlanViewModel';

/**
 * 
 * @export
 * @interface PortfolioSummaryViewModel
 */
export interface PortfolioSummaryViewModel {
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryViewModel
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryViewModel
     */
    clientFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryViewModel
     */
    clientInitial?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryViewModel
     */
    clientLastName?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryViewModel
     */
    openingBalances: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryViewModel
     */
    closingBalances: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryViewModel
     */
    inflows: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryViewModel
     */
    outflows: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryViewModel
     */
    netGrowth: number;
    /**
     * 
     * @type {Array<InvestmentPlanViewModel>}
     * @memberof PortfolioSummaryViewModel
     */
    investmentPlans: Array<InvestmentPlanViewModel>;
}

/**
 * Check if a given object implements the PortfolioSummaryViewModel interface.
 */
export function instanceOfPortfolioSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "openingBalances" in value;
    isInstance = isInstance && "closingBalances" in value;
    isInstance = isInstance && "inflows" in value;
    isInstance = isInstance && "outflows" in value;
    isInstance = isInstance && "netGrowth" in value;
    isInstance = isInstance && "investmentPlans" in value;

    return isInstance;
}

export function PortfolioSummaryViewModelFromJSON(json: any): PortfolioSummaryViewModel {
    return PortfolioSummaryViewModelFromJSONTyped(json, false);
}

export function PortfolioSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'clientFirstName': !exists(json, 'ClientFirstName') ? undefined : json['ClientFirstName'],
        'clientInitial': !exists(json, 'ClientInitial') ? undefined : json['ClientInitial'],
        'clientLastName': !exists(json, 'ClientLastName') ? undefined : json['ClientLastName'],
        'openingBalances': json['OpeningBalances'],
        'closingBalances': json['ClosingBalances'],
        'inflows': json['Inflows'],
        'outflows': json['Outflows'],
        'netGrowth': json['NetGrowth'],
        'investmentPlans': ((json['InvestmentPlans'] as Array<any>).map(InvestmentPlanViewModelFromJSON)),
    };
}

export function PortfolioSummaryViewModelToJSON(value?: PortfolioSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'ClientFirstName': value.clientFirstName,
        'ClientInitial': value.clientInitial,
        'ClientLastName': value.clientLastName,
        'OpeningBalances': value.openingBalances,
        'ClosingBalances': value.closingBalances,
        'Inflows': value.inflows,
        'Outflows': value.outflows,
        'NetGrowth': value.netGrowth,
        'InvestmentPlans': ((value.investmentPlans as Array<any>).map(InvestmentPlanViewModelToJSON)),
    };
}

